var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4606 34.2697C61.4606 30.5423 60.7972 26.9685 59.5806 23.6623C58.7491 33.4038 53.5557 38.4074 48.1291 36.0774C43.0459 33.8937 46.4714 25.3814 46.7245 21.3196C47.1511 14.4342 46.7028 6.55278 34.1956 0C39.3926 9.94215 34.7975 16.1189 29.9783 16.4949C24.6312 16.9125 19.7343 11.8999 21.5419 3.76537C15.6887 8.07845 15.5188 15.338 17.3247 20.0343C19.2082 24.9295 17.2487 28.9967 12.6555 29.4487C7.52169 29.9548 4.6692 23.9516 7.29935 14.3854C2.74765 19.7451 0 26.6866 0 34.2697C0 51.2419 13.7581 65 30.7303 65C47.7025 65 61.4606 51.2419 61.4606 34.2697Z",
    fill: "#F4900C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5189 43.3062C49.7865 48.8811 44.8895 51.0665 42.2539 50.0109C38.447 48.487 39.4683 45.8695 38.4886 40.4465C37.5088 35.0235 33.7434 31.2582 28.1704 29.6005C32.2377 41.0485 25.9162 45.2676 22.6028 46.0213C19.2189 46.7914 15.8186 46.0195 15.43 38.778C11.482 42.7079 9.03809 48.1454 9.03809 54.154C9.03809 54.8193 9.07966 55.4736 9.13751 56.1244C14.687 61.6088 22.31 65 30.7301 65C39.1502 65 46.7731 61.6088 52.3226 56.1244C52.3805 55.4736 52.422 54.8193 52.422 54.154C52.422 50.2007 51.3664 46.4968 49.5189 43.3062Z",
    fill: "#FFCC4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji4);
export default __webpack_public_path__ + "static/media/emoji-4.ca1894a9c13ff4cc8ea21afa298bebb6.svg";
export { ForwardRef as ReactComponent };